import { createRef, useEffect, useRef, useState } from "react";
import { Viewer } from "@photo-sphere-viewer/core";

// import "@photo-sphere-viewer/core/index.css";
import "./Photos.css";

export default function CustomImgPopup({ newSRC }) {
 const sphereElementRef = createRef();

 const [src, setSRC] = useState([]);
 const [currImageIdx, setCurrImageIdx] = useState();

 useEffect(() => {
  setSRC(newSRC);
 }, [newSRC]);

 useEffect(() => {
  if (!!!currImageIdx) {
   const shperePlayerInstance = new Viewer({
    container: sphereElementRef.current,
    panorama: !!src ? src[src.length - 1] : "", // ex: "/360photos/Las Olas - rp4.jpg",
    defaultZoomLvl: 0.1,
    navbar: [
     "zoom",
     // "move",
     {
      id: "change",
      title: "Toggle flooding",
      content: document.querySelector("#icon").innerText,
      onClick(viewer) {
       if (currImageIdx === 1) {
        setCurrImageIdx(0);
        viewer.setPanorama(`${src[0]}`, {
         caption: "",
         description: null,
        });
       } else {
        setCurrImageIdx(1);
        viewer.setPanorama(`${src[1]}`, {
         caption: "",
         description: null,
        });
       }
      },
     },
     // "caption",
     "download",
     "fullscreen",
    ],
    touchmoveTwoFingers: true,
    mousewheelCtrlKey: true,
   });

   // unmount component instructions
   return () => {
    shperePlayerInstance.destroy();
   };
  } else {
   const shperePlayerInstance = new Viewer({
    container: sphereElementRef.current,
    panorama: !!src ? src[0] : "", // "/360photos/Las Olas - rp4.jpg",
    defaultZoomLvl: 0.1,
    navbar: [
     "zoom",
     // "move",
     {
      id: "change",
      title: "Toggle flooding",
      content: document.querySelector("#icon").innerText,
      onClick(viewer) {
       if (currImageIdx === 1) {
        setCurrImageIdx(0);
        viewer.setPanorama(`${src[0]}`, {
         caption: "",
         description: null,
        });
       } else {
        setCurrImageIdx(1);
        viewer.setPanorama(`${src[1]}`, {
         caption: "",
         description: null,
        });
       }
      },
     },
     // "caption",
     "download",
     "fullscreen",
    ],
    touchmoveTwoFingers: true,
    mousewheelCtrlKey: true,
   });

   // unmount component instructions
   return () => {
    shperePlayerInstance.destroy();
   };
  }
 }, [src, currImageIdx]);

 return (
  <>
   <div id="viewer" className="test-image" ref={sphereElementRef} />
  </>
 );
}
